import { Row, Col, Form, notification } from "antd";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { useContext, useState } from "src/ReactTS";
import "./confirmation.scss";
import { PbrSeparator } from "src/components/common/Separator/Separator";
import Panel from "src/components/common/Panel/Panel";
import { FormComponentProps } from "antd/lib/form";
import "../password-recover/PasswordRecover.scss";
import { IUser } from "src/services/interfaces/UserInterface";
import { AuthContext } from "src/components/context/AuthContext";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import { PbrInputMask } from "src/components/common/PbrInput/PbrInputMask";

export default withRouter(Form.create()(Index));

function Index(props: RouteComponentProps<any> & FormComponentProps & { email: string; password: string; user?: IUser; style?: React.CSSProperties }) {
  const authContext = useContext(AuthContext);
  const [codeArr, setCodeArr] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);

  function onChange(e: React.ChangeEvent<HTMLInputElement>) {
    const key = Number(e.target.id.split("num")[1]);

    codeArr[key] = e.target.value;
    setCodeArr(codeArr);
    if (codeArr[key] && key < 5) {
      setTimeout(() => {
        document.getElementById(`num${key + 1}`).focus();
      }, 0);
    }
  }

  function onKeydown(e: React.KeyboardEvent<HTMLInputElement>) {
    const idx = Number(e.currentTarget.id.split("num")[1]);

    if (e.keyCode === 8 && idx > 0) {
      setTimeout(() => {
        (document.getElementById(`num${idx - 1}`) as any).select();
      }, 0);
    }
  }

  async function tryAuthenticate(email, password): Promise<boolean> {
    return new Promise<boolean>(async res => {
      try {
        await authContext.signIn(email, password);
        props.history.push("meus-precatorios");
        res(true);
      } catch (e) {
        res(false);
      }
    });
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    authContext
      .confirmSignUp(props.email, codeArr.join(""))
      .then(() => {
        return authContext.signIn(props.email, props.password);
      })
      .then(() => props.history.push("/meus-precatorios/resumo"))
      .catch(async err => {
        if (err.code === "UnexpectedLambdaException") {
          if (await tryAuthenticate(props.email, props.password)) {
            return;
          }
        }
        console.log(err);
        notification.error({
          message: "Código incorreto",
          description: "Não foi possível validar o código informado"
        });
      })
      .finally(() => setLoading(false));
  }

  function reSendCode(email) {
    authContext.requestEmailConfirmation(email).catch(err => {
      console.log(err);
      notification.error({
        message: "Erro ao solicitar código",
        description: "Não foi possível reenviar um novo código"
      });
    });
  }

  return (
    <div className="decode-confirm-container">
      <span className="decode-recovery-code-header">
        Estamos enviando um código de verificação para o e-mail <strong>{props.email}</strong>
        <br />
        Por favor, digite o código abaixo:
      </span>
      <Form onSubmit={e => handleSubmit(e)}>
        <Panel>
          <Row type="flex" align="middle" justify="center" style={{ marginTop: "30px" }}>
            <Col xs={24} sm={24} md={20} lg={24}>
              <h2 className="decode-recovery-code-title">Código de verificação</h2>
              <div className="input-code">
                {codeArr.map((val, idx) => (
                  <PbrInputMask
                    mask="9"
                    maskChar={null}
                    onChange={e => onChange(e)}
                    onKeyDown={e => onKeydown(e)}
                    autoFocus={idx === 0}
                    style={{ textAlign: "center" }}
                    formWrapper={props.form}
                    name={`num${idx}`}
                  />
                ))}
              </div>
              <PbrSeparator />
            </Col>
          </Row>
          <Row gutter={18} className="actions-btn-row" style={{ marginTop: "30px" }}>
            <Col md={8} sm={24} xs={24} style={{ marginBottom: "15px" }}>
              <StandardButton htmlType="submit" loading={loading} disabled={codeArr.join("").length < 6}>
                Verificar
              </StandardButton>
            </Col>
            <Col md={{ offset: 4, span: 8 }} sm={24} xs={24} style={{ marginBottom: "15px" }}>
              <StandardButton preset="outline" onClick={() => reSendCode(props.email)}>
                Enviar novo código
              </StandardButton>
            </Col>
          </Row>
        </Panel>
      </Form>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/auth/EmailConfirm.tsx